var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main-layout',{staticClass:"pb-2",attrs:{"small":""}},[_c('sent-summary-container',{attrs:{"intro":_vm.intro}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }